/**
 * @file
 * Partner logos JS.
*/
(function ($, Drupal) {

  'use strict';

  /**
   * If mobile, convert Section Heading to toggle for cousin Child Logos.
   *
   * @param {*} element
   */
  Drupal.partnerLogosAccordionToggle = function(element) {
    $('.paragraph--type--partner-logos .paragraph--type--child-section-title').each(function() {
      var $heading = $(this);
      var $cousin = $heading.parent().next().children(':first-child');
      var cousin_is_logos = $cousin.hasClass('paragraph--type--child-logos');

      if (window.innerWidth < 992 && !$heading.hasClass('toggle')) {
        if (cousin_is_logos) {
          $heading.addClass('toggle');
          $cousin.parent().collapse('hide').addClass('collapse');
          $heading.click(function() {
            var test = $(this).parent().next().collapse('toggle');
            if (test.attr('aria-expanded') == "true") {
              $heading.addClass('open');
            } else {
              $heading.removeClass('open');
            }
          });
        }
      } else if (window.innerWidth > 993 && $heading.hasClass('toggle')) {
        $heading.removeClass('toggle').removeClass('open');
        $heading.unbind('click');
        $cousin.parent().collapse('show');
      }
    });
  }

  /**
   * Attach function run Drupa..parnterLogosAccordionToggle.
   */
  Drupal.behaviors.partnerLogos = {
    attach: function(context, settings) {
      $(once('partnerLogos', document, context)).each(function() {  
        Drupal.partnerLogosAccordionToggle();
        $(window).resize(Drupal.partnerLogosAccordionToggle);
      });
    }
  }

})(jQuery, Drupal);